module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_15",
      "title": "[15]"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "CHAPTER_II"
    }
  }, [_vm._v("CHAPTER II."), _c('br', {
    staticClass: "calibre"
  }), _vm._v(" "), _c('span', {
    staticClass: "fs2"
  }, [_vm._v("“JACKSON DANE, DETECTIVE.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("At the Eagle House, an hour afterward, the man shot at by Juniper Joe appeared before the door of Buffalo Bill’s room, and rapped.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Nomad, who was in the room with the scout and the baron, being nearest the door, drew it open.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The little man came in, glancing narrowly around; a quiet man, apparently mild-mannered. There was nothing remarkable in his looks; in a crowd he would have been passed without notice. Yet to the keen eyes of Buffalo Bill the man’s very quietness of manner spoke of reserve force and repression.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Cody, is it not?” said the little man, addressing the scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The same,” the scout answered. “Have a chair with us. These are my good friends, Nick Nomad and Baron von Schnitzenhauser.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Glad ter meet up with ye,” said Nomad, as the stranger tucked himself into the first chair.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Aber I tond’t knowed you, I gan say der same py mineselluf,” seconded the German.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The stranger regarded them closely.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Thanks!” he said. “I think all you fellers was up at Juniper Joe’s when he took them shots at me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Ouch! We seen idt! One of dose pullets vhistled so close py mine ear dot I t’ink I can hear him yidt.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I fancy they didn’t come as close to you as to me!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_16",
      "title": "[16]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The little man ran his hand through his hair, and revealed a red welt on his forehead, just under the hair he had lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“One of them came as near to me as that. I wonder it didn’t knock me out. I still had enough sense to pull for the lamp, as I went down; then I crawled out through the door, and got away.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He looked at the three men curiously, as if wondering what they thought of it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It was quick shooting!” was the comment of Buffalo Bill.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The man had not yet introduced himself; and the scout did not forget that Juniper Joe had charged him with being Benson, the road agent, a man the scout had never met, but whom he wished right then he could surely lay his hands on.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("In truth, Buffalo Bill and his friends had been discussing this very man when he appeared at the door and came in.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“What was said about me, after the shooting?” the stranger asked, drawing one leg over the other and settling into an easy attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I suppose you want us to be quite frank with you?” said the scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“That’s what I’m expecting, gents. I knew something would be said, and I fancied you heard it. I confess I got away so quick that, whatever it was, I lost it. The climate there didn’t seem healthy for me; so I tried as fast as I could to change it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He smiled, then—a thin-lipped smile, that had little merriment in it.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Juniper Joe declared,” the scout told him directly,"), _c('a', {
    attrs: {
      "id": "Page_17",
      "title": "[17]"
    }
  }), _vm._v(" “that you were Tim Benson, the outlaw and road agent; that he recognized you, as soon as you came through the door, as being the man who had held up a stage at Holbrook and robbed it, getting five thousand dollars of his money; for which he had sworn to kill you on sight.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("That thin-lipped smile, sneering now, became evident again.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“A clever yarn, to be made up so quickly!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Then, it wasn’t true?” the scout queried.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Not a word of it. On the contrary, instead of being Tim Benson, I am Jackson Dane, of San Francisco, in the detective business, and came here looking for Tim Benson myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Ach! Iss dot so-o?” gasped the baron.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It’s so.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Py yiminy, dhen——”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But the scout cut in, to keep the baron from making some damaging statement:")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I suppose there must be something in your general appearance which caused Juniper Joe to make that fool mistake?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The stranger laughed at that.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“If so, it came near being a fatal blunder for me!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The scout and his pards were making a careful study of the man, without appearing to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It was a clost call,” said Nomad. “But yer war too quick fer him! Shootin’ out ther lights is a star play, ef a man kin do et; an’ you rung the bell at the fust crack. Buffler, here, couldn’t done et no better.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Thanks for the compliment! But”—turning to Buffalo Bill—“I don’t think I much resemble Benson, except that we are both small men—rather undersized, you"), _c('a', {
    attrs: {
      "id": "Page_18",
      "title": "[18]"
    }
  }), _vm._v(" know; which is a marked thing in this country, where nearly all the men are so big.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Size an’ heft don’t allus count,” said Nomad naïvely. “F’r instance, thar’s Buffler, an’ thar’s me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I judge that it’s your opinion,” the scout remarked, “that Juniper Joe didn’t make any mistake?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“No; he simply lied.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’ll have to leave that to you; for I don’t know.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Unless he really made a mistake, and thought you were Benson, he wouldn’t have any reason to want to shoot you?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“If he had any reason, I don’t know it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Then, we may suppose that, seeing you there by the door, and not having time to correct his first impression, he felt sure you were Benson, and blazed away.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Mighty careless of him to do that!” said the stranger.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("His light-blue eyes twinkled, as if the thing amused him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Then he shifted his legs, and for a moment the conversation seemed stalled. He probably had noticed by this time that the scout was closely watching him!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“One of the things bringing me here,” he said, breaking the silence, “was to find out if you fellows air barking up the same tree; that is, to see if you came here chasin’ Tim Benson?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“If so?” the scout queried.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, then, I didn’t know but that somehow we might make shift to work the thing together—me giving you whatever tips I run acrost, and you doin’ the same by me. There’s a reward of ten thousand out for Benson, half of it put up by the Wells Fargo. I’d like to handle"), _c('a', {
    attrs: {
      "id": "Page_19",
      "title": "[19]"
    }
  }), _vm._v(" all of it, of course; but if I can’t swing the thing alone, I’d be willing to divide up with good men like you; in case we could work the thing by a combination better than singly.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You know about me,” said the scout; “that is, that I’m in the employment of the government, as a scout, and for other special purposes; so, of course, you will see readily that if I came here with my friends looking for Benson, it is because Benson has been troubling the mails.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Yes, I know that, or supposed it. As for me, I fly alone; in the private detective line, you know; just now on the trail of that ten thousand dollars reward, and hoping I’ll land it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“That isn’t what I meant.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“No? What did you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“That you have my credentials—that is, you know something about me. "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("I don’t know anything about you!")]), _vm._v(" It’s an important matter; so I hope you won’t mind my bluntness.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“But I’ve told you!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“But shown no papers, nor even a badge. You must have some source of authority, I suppose?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("For an instant the man who had given the name of Jackson Dane seemed to hesitate.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“The truth is,” he said, “though likely you won’t believe it, that I lost everything in that hotel fire at Deming, where I was last week; just got out by the skin of my teeth; so that my extra clothing and everything else went up in smoke.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Er, waugh!” Nomad gulped.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You think that is fishy?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_20",
      "title": "[20]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I didn’t say et!” the trapper apologized. “Et’s jes’ a way I has o’ breathin’ hard, at times.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You haven’t any letters which you have received since?” Buffalo Bill questioned.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, yes: just one!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Jackson Dane pulled out what seemed at first a letter, but was discovered to be an envelope from which the letter was gone; it bore the postmark of Blossom Range, and the date of that very day.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I got this letter here this morning, soon after I struck the town,” he explained.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The scout looked at the envelope, noting that it bore the address of “Mr. Jackson Dane, Blossom Range,” but that it held no letter.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I see,” he said; but his tone was noncommittal.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“That’s all I’ve got right now, in the way of credentials,” said the little man.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You’ll pardon me for saying,” said the scout quietly, “that since Juniper Joe tried to kill you because he claimed you are Tim Benson, it would hardly be politic for me to enter into any arrangements with you, of the kind you mention.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Jackson Dane flushed slightly.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Sorry you look at it in that way,” he said. “But for that fire in Deming, I could prove who I am, even to your satisfaction.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He sat in hesitation, looking from one to the other. Then he seemed about to put on his hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Just what do you know about Juniper Joe?” the scout inquired of him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“No more than what everybody else knows here in the town, I reckon: he has struck it rich in his mine,"), _c('a', {
    attrs: {
      "id": "Page_21",
      "title": "[21]"
    }
  }), _vm._v(" has taken a wife, and is celebrating. I can’t say that I admire his judgment, that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“In taking a wife in that way?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Just so. What does he know about her? She answers his advertisement, which says that he is rich, and comes on. Mebby they’ll git along together; but the chances are that they’ll be fighting like cats and dogs inside of a month. I know that all of life is a gamble; yet I wouldn’t take fool risks.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He put on his hat, and arose to go.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Sorry, gents, that we can’t make a hitch,” he said. “But I can ask this of you: Don’t mention it so’s Juniper Joe will know I’ve been here. As he seems convinced that I’m Tim Benson, I reckon I’ll have to keep out of his sight; or else get myself ready to shoot quicker than he can. I don’t care to get into trouble here in this town, as that would interfere with the work that brought me.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He turned to the door.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Nomad sat, crouched, as if he thought of hurling himself at the stranger and stopping him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("But as Buffalo Bill made no movement, the trapper held his impulse in check; and Jackson Dane, of Frisco, wended his way down the stairs in peace.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Er, waugh!” Nomad gurgled, when he was gone. “Waugh!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, out with it, if it hurts you,” the scout told him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Didn’t et strike ye thet mebby Juniper Joe told ther truth, and that we’re lettin ’ther very critter we’re after git erway?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I am yoost t’inking dot mineselluf,” said the baron; though he did not seem excited.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_22",
      "title": "[22]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Buffalo Bill produced a flat pocketbook, and extracted from it a tintype picture.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("It was of a miner, in red shirt and clay-stained trousers, leaning on the handle of a miner’s pick. He looked at it closely; then passed it to Nomad.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The round-bodied German climbed out of his chair, and came over to inspect it with Nomad, looking over the trapper’s shoulder.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Waal, et’s powerful hard ter decide a matter like thet,” said Nomad. “This hyar was taken all o’ five y’ars ago, I reckon; and ’tain’t anything much of a pickcher. Yet put the clo’es this hyar Jackson Dane war w’arin’ outer ther man in this, an’ et might be ther same feller.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Aber dhey tond’t look der same, idt mighdt pe,” confessed the baron; “budt dhis veller he iss vearin’ a musdache.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“’Twouldn’t be hard ter shave et off, I reckon,” Nomad reminded.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The resemblance between the man in the tintype and Jackson Dane could not be said to be marked. Both were apparently of about the same size, the stature of the man in the tintype being judged by the height of the pick. They had been told that the original of the picture was light-haired and blue-eyed. So was Jackson Dane.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("The man in the tintype was the outlaw and road agent, Tim Benson. They had come to Blossom Range looking for him. Two weeks before he had been working the Blossom Range stage trails, taking heavy toll. He had, likewise, not hesitated to lay his hands on valuables carried in Uncle Sam’s mail bags; for which reason Buffalo Bill had been sent on his trail. From the"), _c('a', {
    attrs: {
      "id": "Page_23",
      "title": "[23]"
    }
  }), _vm._v(" vicinity of Blossom Range he had skipped into other territory; then had been heard of in Deming; when last seen, he was said to be making back toward Blossom Range.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("That was about all that the scout knew, and it was little enough. Five years before, Tim Benson had been a miner, in a little place near Virginia City; it was there he had this picture taken, by a traveling tintype artist, leaning on his miner’s pick.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Vale,” said the baron, “I am sduck! Vot ar-re ye going to do?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I think I shall try for a talk with Juniper Joe,” said the scout.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Et might jump suthin’ outer ther bresh,” Nomad agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Eenyhow,” the baron added, “I am hobing dot soon ve vill pe scaring oop some adwentures dot haf a liddle excidemendts in ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("They were still talking the thing over, the little man not having been gone ten minutes, when the scout had another visitor, who came to the door of his room at the Eagle House, and knocked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Again Nomad drew open the door.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("All were surprised to see the object of their talk—Juniper Joe, tall and thin, dressed in his black broadcloth, the tails of his coat suspiciously lifted by the big revolvers that rested against his hips. He looked carefully at the scout’s companions; then came on in, when invited.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I don’t keer if I do,” he said, when the scout asked him to take a chair.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_24",
      "title": "[24]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He helped himself to the one which the little man had occupied so short a while before.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You-all was at the jubilee to-night,” he said, running his eyes over them; “and so know what happened ter break up the gin’ral hilarity o’ that festive occasion. Because o’ which I’m hyer, when I ought ter be thar with my blushin’ bride this minute. I believe that the town gin’rally thinks that the only mistake I made was in not gittin’ the coyote I shot at; which you heerd me say was Tim Benson, the road agent.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Er, waugh! We heerd yer!” Nomad told him.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You know somethin’ about Benson?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Not so much but thet our cur’osity is ixcited ter hear more.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Juniper Joe turned to Buffalo Bill.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I reckon you’re hyer trailin’ somebody. It’s considered lately that you aire, when you pike into a town like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I might be traveling for my health, you know,” Buffalo Bill observed, with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“When already yer has got ther health o’ a grizzly? Nobody’d think it. No; you come hyer fer somebody; and I’ve been figgerin’ that it must be you’re lookin’ for Benson, because he’s known to have been in this section recent, doin’ hold-up work, as I said thar at my house.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Have you known him well?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I never seen him clost but onct; but then I had so good a look at him that I spotted him to-night as soon’s he poked his nose in at the door. Too bad that when I pulled on him I didn’t git him! Of course, he’s still in the town; and I reckon if chanct comes his way, he’ll"), _c('a', {
    attrs: {
      "id": "Page_25",
      "title": "[25]"
    }
  }), _vm._v(" make the new Mrs. Joe ag’in a widder. But I’m heeled fer him!”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He dropped a hand to the bulging revolvers.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“He’ll haf to pot me from the dark, if he gits me!” he boasted. “But that ain’t what I come over hyer to elucidate, after leavin’ my bride of an hour er so to home all alone, which ain’t a proper thing fer any man to do; and I wouldn’t do it but for the circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You-all aire knowin’ to the fact,” he went on, “that lately I’ve been hittin’ it big in my mine. Sense the Wells Fargo sent out its last shipment, I’ve pulled out o’ that mine gold dust and nuggets to the amount of ten thousand dollars’ worth. To-morrow the Wells Fargo is goin’ to ship it out fer me, with stuff from a good many other mines round hyer; I reckon thar’ll be fifty thousand dollars go out in the express company’s cash boxes to-morrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Buffalo Bill, having been so short a time in the place, did not know this, and was interested.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“So-o?” said the baron. “Dot iss more gold as I haf effer seen in one bunches.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Et’s er heap,” Nomad admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I reckoned,” went on Juniper Joe, “that you-all would be takin’ a hand in gyardin’ that stage load of wealth when she pulls out. So I’ve come to give ye a pinter. Jest in the cañon tother side o’ Stag Mountain is whar you’re likely to have trouble; in my opinion, if the agents hits you, it will be right thar. I say this so’s you can be ready for ’em.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“As the Wells Fargo people haven’t told us anything about it,” said the scout, “I think it is unlikely they will ask our help.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('a', {
    attrs: {
      "id": "Page_26",
      "title": "[26]"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“But the mail goes through on the same stage, you know,” Juniper Joe explained. “I jedge it’s the mail that you’re most int’rested in?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Aber you tond’t know vhere diss roadt achent iss vot you shodt at,” said the baron, “I exbose dot you vill pe looking for him yourselluf?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Waal, I’ll kinder keep my eyes peeled, as I ambles round the town,” Juniper Joe admitted. “Ye see, I think he’ll lay low, now that he knows he has been spotted. But it’s him being hyer which makes me figger that the bullion stage to-morrow is goin’ to have er heap of fun gittin’ through?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“You think,” said the scout, “that he will hold it up, at the place you mentioned?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I figger that he has got friends hyer, and they’ll help him do it. I’m goin’ to say to the Wells Fargo folks what I’ve said to you. And I’m goin’ to make ’em a suggestion, which I now make to you. Why wouldn’t it be a good idea to send the old stage out empty, but with gyards in it? Make a bluff, ye see, which will cause Tim Benson an’ his gang to think the bullion, nuggets, an’ dust aire goin’ that way. Then put the stuff over the mountains in some other manner, which the agents wouldn’t git onto.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It might do,” the scout admitted.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Uff he tond’t gatch onto it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“It can be kept quiet,” said Juniper Joe. “I jest wanted to say these things, and have ye think ’em over to-night. Now I got to git back to my new wife; er she’ll be thinking that mayby I’ve run up ag’inst the pistol of Benson. She didn’t want me to come down hyer to-night,"), _c('a', {
    attrs: {
      "id": "Page_27",
      "title": "[27]"
    }
  }), _vm._v(" on that account. Women aire gin’rally skeery critters, ye know.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("He pulled himself out of his chair; then went out and downstairs, walking slowly, as if he were thinking over the situation.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Er, waugh!” Nomad whooped again, when he was gone. “What does yer make o’ "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("thet")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“I’ll know better when I’ve had a talk with the Wells Fargo people,” was the scout’s answer. “That’s what I’m going to do now, if I can find them at this time of night.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When the scout and his pards found the Wells Fargo people, which was not for an hour afterward, as the express office had long been closed for the day, they discovered that Juniper Joe had deviated far enough from his homeward track to get there with his advice ahead of them.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“His idea is so good,” said the Wells Fargo agent, “that we’re going to adopt it. We’ll send out the stage empty, but with a strong guard in it. If the agents hold it up, we’ll have a chance of shooting them all to pieces; and they will secure nothing, even if they get into it.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“How will you send the stuff?” the scout asked.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("Though the agent was in his own home, he got out of his chair and, going outside, walked all round the house, to see if possible eavesdroppers could be there.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("When he came back he was satisfied.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Well, I’ll tell you,” he said. “We’ll send the stuff over the mountains in charge of two prospectors that we "), _c('em', {
    staticClass: "calibre5"
  }, [_vm._v("know")]), _vm._v(" are reliable—Jack Austin and Bennett Brown. They’ll take burros, and will pretend to be setting out on a prospecting trip; and so throw off any suspicion. When"), _c('a', {
    attrs: {
      "id": "Page_28",
      "title": "[28]"
    }
  }), _vm._v(" they get down out of Eagle Gap, they’ll swing to the east, and put the stuff on the stage at Colorow Springs, where the stage will be instructed to wait for them. Beyond that point there won’t be much danger, as the country is open and level, and a hold-up wouldn’t be attempted.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Der only t’ing,” said the baron, “iss, vill idt vork? I vouldt like to go mit Austin unt Prown.”")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Why?” said the agent.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_vm._v("“Because, in my obinion, dot iss vhere der excidement iss going to pe seen; unt I am fondt uff excidemendts.”")]), _vm._v(" "), _c('hr', {
    staticClass: "chap2"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5e34d0c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0005.vue
// module id = 69
// module chunks = 0